
import { defineComponent, ref, toRefs, watch, nextTick, PropType } from 'vue'

export default defineComponent({
    name: 'VideoDialog',
    props: {
        videoTitle: String,
        visible: Boolean,
        header: String,
        videos: {
            type: Array,
            default: () => [],
        },
        videoNames: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
    },
    setup(props, { emit }) {
        const { visible } = toRefs(props)
        const video = ref<HTMLVideoElement>()
        const tabPosition = ref('top')
        watch(visible, async () => {
            if (visible.value) {
                console.log('video dialog 打开了')
                console.log(props.videoNames)
                // 等待视频加载完成
                // await nextTick()
                // // 取默认第一个视频时间来播放
                // initPlayer(0)
                await nextTick()
                video.value = document.getElementById('video' + 1) as HTMLVideoElement
                console.log('video.value: ', video.value)
                video.value?.play()
                if (screen.availWidth < 500) {
                    tabPosition.value = 'top'
                } else {
                    tabPosition.value = 'left'
                }
            }
        })

        const videoBeginTime = ref(0)
        const currentTime = ref(0)
        const duration = ref(10)
        const timer = ref(0)
        const seekTo = (seekTime: number) => {
            if (video.value) {
                video.value.currentTime = videoBeginTime.value + seekTime
            }
        }

        /**
         * 初始化播放器的参数
         */
        // eslint-disable-next-line no-unused-vars
        const initPlayer = (index: number) => {
            let seekTime = getVideoTime(props.videoNames[index] as string)
            video.value = document.getElementById('video' + (index + 1)) as HTMLVideoElement

            if (isIPhone()) {
                // alert('iphone')
                video.value.addEventListener('canplay', function () {
                    //设置播放时间
                    if (video.value) {
                        video.value.currentTime = seekTime <= 8 ? 0 : seekTime - 8
                        videoBeginTime.value = seekTime <= 8 ? 0 : seekTime - 8
                        currentTime.value = 0
                        playOrPause(true)
                    }
                })
            } else {
                video.value.currentTime = seekTime <= 8 ? 0 : seekTime - 8
                videoBeginTime.value = seekTime <= 8 ? 0 : seekTime - 8
                currentTime.value = 0
                playOrPause(true)
            }
        }

        /**
         * 截取数据获得视频的url
         */
        const getVideoPath = (timeStr: string) => {
            // return timeStr.substring(0, 2) + ".mp4"
            return timeStr + '.mp4'
        }

        /**
         * 截取数据获得视频的开始时间
         */
        const getVideoTime = (timeStr: string) => {
            let time = timeStr.substring(3)
            let seekTime = Number(time.slice(0, 2)) * 60 + Number(time.slice(2))

            return seekTime
        }

        const changeVideo = async (v: any) => {
            if (video.value) {
                console.log('切换标签，要暂停这个视频', video.value)

                video.value.pause()
                await nextTick()
                // initPlayer(v)
                video.value = document.getElementById('video' + (v + 1)) as HTMLVideoElement
                video.value?.play()
            }
        }
        const handleCancel = () => {
            if (video.value) {
                video.value.pause()
            }
            emit('close', null)
        }
        const tabName = (i: number) => {
            if (props.videoNames.length > 0) {
                return props.videoNames[i]
            } else {
                return i + 1
            }
        }

        /**
         * 收到拖动的监听，将currentTime设置值
         */
        const trag = (shortTime: number) => {
            console.log('emit到的shortTime===', shortTime)
            if (video.value) {
                video.value.pause()
            }
            currentTime.value = shortTime
            seekTo(shortTime)
        }

        /**
         * 拖动结束播放
         */
        const tragEnd = () => {
            if (video.value) {
                playOrPause(true)
            }
        }

        /**
         * 播放或者暂停，同时算出当前视频播放的时间，到最长则暂停播放
         */
        const playOrPause = (v: boolean) => {
            if (video.value) {
                if (v) {
                    video.value.play()
                    timer.value = setInterval(() => {
                        if (video.value) {
                            if (currentTime.value >= duration.value) {
                                video.value.pause()
                                clearInterval(timer.value)
                            } else {
                                currentTime.value = video.value.currentTime - videoBeginTime.value
                                // alert(currentTime.value)
                            }
                        }
                    }, 20)
                } else {
                    video.value.pause()
                }
            }
        }

        const fullScreen = () => {
            if (video.value) {
                console.log('全屏')
                document.getElementById('content1')!.requestFullscreen()
                // video.value.requestFullscreen()
            }
        }

        //判断是否安卓设备
        const isIPhone = () => {
            var u = navigator.userAgent
            // alert(u)
            if (u.indexOf('iPhone') > -1) {
                return true
            }
            return false
        }
        return {
            changeVideo,
            handleCancel,
            tabName,
            trag,
            duration,
            tragEnd,
            playOrPause,
            currentTime,
            getVideoPath,
            fullScreen,
            tabPosition,
        }
    },
})
